<template>
    <KvModal size="small" ref="modal">
        <template #title>{{ t('orders-confirm_delete-title') }}</template>
        <template #body>
            <div class="text-danger mb-3 confirm-delete-warning-text">
                {{ t(count === 1 ? 'orders-confirm_delete-body_singular' : 'orders-confirm_delete-body_plural') }}
            </div>
            <div class="text-danger mb-3 confirm-delete-warning-text">
                {{ t('orders-confirm_delete-warning') }}
            </div>

            <KvTypography color="primary" class="mb-4">
                {{ t(count === 1 ? 'orders-confirm_delete-inconsistency_singular' : 'orders-confirm_delete-inconsistency_plural') }}
            </KvTypography>

            <div class="confirm-delete-phrase">
                <KvTypography color="secondary" size="small">{{ t('orders-confirm_delete-instruction') }}</KvTypography>
                <div class="confirm-delete-phrase-text">
                    <span v-for="(char, index) in phrase" :key="index" :class="{ matched: isCharMatched(index) }">{{ char }}</span>
                </div>
                <KvInput v-model="userInput" :placeholder="phrase" />
            </div>
        </template>
        <template #footer="{ toggle }">
            <div class="d-flex align-items-center w-100 justify-content-end gap-sm">
                <KvButton variant="outlined" @click="toggle">{{ t('cancel') }}</KvButton>
                <KvButton variant="filled" class="btn-danger-filled" prepend-icon="ui-trash-01" :disabled="!isPhraseCorrect" @click="confirm">
                    {{ t('orders-confirm_delete-button') }}
                </KvButton>
            </div>
        </template>
    </KvModal>
</template>

<script>
import KvModal from "@/components/modal/modal.vue";
import KvTypography from "@/components/ui/kv-typography.vue";
import KvInput from "@/components/inputs/kv-input.vue";
import KvButton from "@/components/form/kv-button.vue";

export default {
    name: "OrdersConfirmDelete",
    components: { KvModal, KvTypography, KvInput, KvButton },
    props: {
        count: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            userInput: "",
        };
    },
    computed: {
        phrase() {
            const key = this.count === 1 ? "orders-confirm_delete-phrase_singular" : "orders-confirm_delete-phrase_plural";
            return this.t(key, [this.count]).toUpperCase();
        },
        isPhraseCorrect() {
            return this.userInput.trim().toUpperCase() === this.phrase;
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isCharMatched(index) {
            const typed = this.userInput[index];
            return typed !== undefined && typed.toUpperCase() === this.phrase[index];
        },
        open() {
            this.userInput = "";
            this.$refs.modal.open();
        },
        close() {
            this.$refs.modal.close();
        },
        confirm() {
            if (!this.isPhraseCorrect) return;
            this.close();
            this.$emit("confirm");
        },
    },
};
</script>

<style lang="scss" scoped>
.confirm-delete-warning-text {
    color: #DE3024; 
    font-weight: 500;
}

.confirm-delete-phrase {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 20px;
}

.confirm-delete-phrase-text {
    font-weight: 500;
    letter-spacing: 0.5px;
    white-space: pre-wrap;
    color: #6b7280;

    .matched {
        color: #dc2626;
    }
}
</style>
